import {Accordion, Column, Text} from 'components-lib';
import {fetchPhasesThunk} from 'filters-selections';
import {FormNameEnum} from 'filters-selections/enums';
import {filtersPhasesEntitiesCollectionSelector} from 'filters-selections/store';
import {Form} from 'forms';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IWithDisabled} from 'models';

export function PhaseFilter({disabled}: IWithDisabled) {
  const dispatch = useDispatch();
  const phases = useSelector(filtersPhasesEntitiesCollectionSelector);

  useEffect(() => {
    if (!phases.length) {
      dispatch(fetchPhasesThunk());
    }
  }, [phases.length, dispatch]);

  return (
    <Accordion heading="Phase">
      <Column>
        {phases.length ? (
          phases.map((phase) => (
            <Form.Checkbox
              key={phase.id}
              name={FormNameEnum.phase}
              value={phase.id}
              label={phase.displayText}
              disabled={disabled}
            />
          ))
        ) : (
          <Text.Caption>No Phases</Text.Caption>
        )}
      </Column>
    </Accordion>
  );
}
